module.exports = __webpack_public_path__ + "img/workContents01_sp_04.79db7477.png";